export const types = {
  plans: "[GET] Plans",
  addPlans: "[POST] Plans",
  removePlans: "[DELETE] Plans",
};
